import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { styled } from 'styled-components';
import '../ScrollGroup/index.mjs';
import { useStickyGrid } from './context.mjs';
import { useScrollGroupItem } from '../ScrollGroup/useScrollGroupItem.mjs';
"use strict";
function StickyGridBody({
  children
}) {
  const {
    templateColumns,
    gap
  } = useStickyGrid();
  const contentRef = useRef(null);
  useScrollGroupItem({
    refObject: contentRef
  });
  return /* @__PURE__ */jsx(StyledStickyContent, {
    ref: contentRef,
    $templateColumns: templateColumns,
    $gap: gap,
    children
  });
}
const StyledStickyContent = styled.div`
  display: grid;
  gap: ${({
  $gap
}) => $gap ?? 0};
  grid-template-columns: ${({
  $templateColumns
}) => $templateColumns};
  width: 100%;

  overflow: auto;
  overscroll-behavior-x: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
export { StickyGridBody };
//# sourceMappingURL=StickyGridBody.mjs.map
